import { FormsWritebacks } from '@frontend/api-forms';
import { SourceIdToLocationIdsAssociation } from './types';

function checkSettingTypeCapability(
  capabilities: FormsWritebacks.Types_v3.WritebackCapability[],
  settingType: FormsWritebacks.Types.WritebackCapabilitySettingType
) {
  const capability = capabilities.find((c) => c.settingType === settingType);
  if (!capability || !capability.isCapable) {
    return false;
  }

  return true;
}

interface GetSourceIdToLocationIdsAssociationForMedicalConditionsPayload {
  capabilities: FormsWritebacks.Types_v3.WritebackSource[];
  associationRef: SourceIdToLocationIdsAssociation[];
  locationId: string;
}

/**
 * This function will populate the associationRef with the sourceId and locationIds that are associated
 * with the medical conditions tab.
 */
function associateSourceIdToLocationIdsForMedicalConditions({
  associationRef,
  capabilities,
  locationId,
}: GetSourceIdToLocationIdsAssociationForMedicalConditionsPayload) {
  capabilities.forEach((source) => {
    if (checkSettingTypeCapability(source.capabilities, 'medical_condition_tab')) {
      const index = associationRef.findIndex((s) => s.sourceId === source.sourceId);
      if (index !== -1) {
        associationRef[index].associatedLocationIds.push(locationId);
      } else {
        associationRef.push({
          sourceId: source.sourceId,
          associatedLocationIds: [locationId],
        });
      }
    }
  });
}

export const WritebackCapabilitiesUtils = {
  checkSettingTypeCapability,
  associateSourceIdToLocationIdsForMedicalConditions,
};
